export const MONEY = 'USD ICC';
export const UNITS = 'NÚMERO DE PARTES POR ICC';
export const SALES = 'VENTAS';
export const AVERAGE = 'MESES DE STOCK';
export const LINES_OBJ_NAME = 'lines';
export const TOTAL_COLUMN = 'Total';
export const BUTTONS_BOTTOM = [MONEY, UNITS, AVERAGE];
export const COLORS_CHART_TYPE = [
  '#00A0DF',
  '#0C36EB',
  '#0C76F5',
  '#0CF0F5',
  '#0CEBB0',
  '#499F9E',
  '#46B5E0',
  '#FF7F00',
  '#499F9E',
  '#499F9E',
  '#499F9E',
];
